import React        from 'react';
import useIsMounted from '@hooks/use-is-mounted';
import ReactPlayer  from 'react-player';
import { CSection } from '@core/components/common/CSection';
import { usePropertyState } from "@core/providers/PropertyStateProvider";

import useStyles    from './VideoSection.styles';


export const VideoSection: React.FC = () => {

    const { classes } = useStyles();
    const isMounted = useIsMounted();

    const { propertyDetailsData } = usePropertyState();

    const url = propertyDetailsData?.images?.filter((img) => img.type === 'video' && img)[0]?.src;

    return isMounted &&
        propertyDetailsData !== null &&
        propertyDetailsData?.images?.length > 0 && (
        <CSection
            heading="Video tour of the property"
            content={
                <ReactPlayer
                    className={classes.videoPlayer}
                    url={url || 'https://www.youtube.com/watch?v=8nbcdqOaWvk'}
                    playing={false}
                    loop={false}
                    light={false}
                    controls={true}
                    muted={true}
                    width="100%"
                    height="377px"
                    // playIcon={}
                    // config={}
                    // volume={100}
                />
            }
        />
    )

}
